import React, { useState, useEffect } from "react";
import axios from "axios";
import $ from "jquery";
 //import Box from "@mui/material";
import Card from "@mui/material/Card";
import Typography from "@mui/material/Typography";
import { Grid } from "@mui/material";
import Avatar from "@mui/material/Avatar";
import PhotoCameraIcon from "@mui/icons-material/PhotoCamera";
import Badge from "@mui/material/Badge";
import Button from "@mui/material/Button";
import Modal from "@mui/material/Modal";
import ProfileForm from "./form/ProfileForm";
import { Icon } from '@iconify/react/dist/iconify.js';
import ChangePwdForm from "./form/ChangePwdForm";
import Dropzone from "./form/Dropzone";
import CloseIcon from "@mui/icons-material/Close";
 // STYLES
const styles = {
  details: {
    padding: "1rem",
    borderTop: "1px solid #e1e1e1"
  },
  value: {
    padding: "1rem 2rem",
    borderTop: "1px solid #e1e1e1",
    color: "#899499"
  }
};
const ProfileLayer = () => {
    let activeuser =localStorage.getItem('activeUser');
    activeuser =  JSON.parse(activeuser);
    
    const [infoModalShow, setInfoModalShow] = useState(false);
    const [modalinfo, setModalInfo] = React.useState(<></>);
 
    const handleOpenProfile = async () => {
      setInfoModalShow(true);
      let Modalcontent = <ProfileForm handleClose={handleClose} />;
      setModalInfo(Modalcontent);
  };

  const handleOpenChangepwd = async () => {
    setInfoModalShow(true);
    let Modalcontent = <ChangePwdForm handleClose={handleClose} />;
    setModalInfo(Modalcontent);
};
  const handleOpen = async () => {
       setInfoModalShow(true);
      let Modalcontent =  <Dropzone handleClose={handleClose} />;
      setModalInfo(Modalcontent);
  };

  const handleClose = () => {
      setInfoModalShow(false);
    
  };

  const style = {
      position: 'absolute',
      top: '30%',
      left: '50%',
      transform: 'translate(-50%, -50%)',
      width: '60%',
      height: 'fit-content',
      bgcolor: 'background.paper',
      border: '2px solid #000',
      boxShadow: 24,
        backgroundColor: '#fff'
  };


    return (
      <div className="card basic-data-table">
       <Modal
                            open={infoModalShow}
                            onClose={handleClose}
                            aria-labelledby="modal-modal-title"
                            aria-describedby="modal-modal-description"
                            className="mt-3"
                        >
                            <div style={style} className="p-3">
                                <Typography id="modal-modal-title " variant="h6" component="h2">
                                    <div style={{ float: 'right' }}>
                                        <span onClick={handleClose} style={{ marginRight: "5px", textDecoration: 'cursor' }}><CloseIcon /></span> </div>

                                </Typography>
                                <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                                    <div>{modalinfo}</div>
                                </Typography>
                            </div>
                        </Modal>
       <div className="card-body">
         <Card variant="outlined">
      <Grid
        container
        justifyContent="center"
        alignItems="center"
        className="row"
      >
         <Grid item xs={6} className="col-md-6 col-sm-6 col-xs-12"  sx={{ p: "1.5rem 0rem", textAlign: "center" }}>
           
             <Badge
            overlap="circular"
            anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
            badgeContent={
              <PhotoCameraIcon
                sx={{
                  border: "5px solid white",
                  backgroundColor: "#ff558f",
                  borderRadius: "50%",
                  padding: ".2rem",
                  width: 35,
                  height: 35
                }}
                onClick={handleOpen}
              ></PhotoCameraIcon>
            }
          > 
            <Avatar
              sx={{ width: 100, height: 100, mb: 1.5 }}
              src={(activeuser.image != "")? process.env.REACT_APP_BASE_URL+activeuser.image:"https://media.glamour.com/photos/5a425fd3b6bcee68da9f86f8/master/pass/best-face-oil.png"}
            ></Avatar>
          </Badge>

           <Typography variant="h6">{" "+activeuser.name}</Typography>
          <Typography color="text.secondary">{" "+activeuser.user_type}</Typography>
          <button   onClick={handleOpenChangepwd}
              className="btn btn-default  " title="Change Password"  > Change Password   </button>
          
        </Grid>
        
        <Grid  className=" card col-md-6 col-sm-6 col-xs-12"  item xs={12} sm={6}  container>
          <Grid  item xs={12} className="card-header">
            <button   onClick={handleOpenProfile}
              className="btn btn-default float-right" title="Edit profile" style={{float:"inline-end"}}><Icon icon="lucide:edit" />   </button>
               <h4> Profile Information </h4>
          </Grid>
          <Grid item xs={6}>
            <Typography style={styles.details}>Name</Typography>
            <Typography style={styles.details}>Email </Typography>
            <Typography style={styles.details}>Phone No </Typography>
            <Typography style={styles.details}>User Type </Typography>
       
            <Typography style={styles.details}>Country</Typography>
            <Typography style={styles.details}>State </Typography>
            <Typography style={styles.details}>City  </Typography>
            <Typography style={styles.details}>Address   </Typography>
            <Typography style={styles.details}>Pincode   </Typography>
          </Grid>
           <Grid item xs={6} sx={{ textAlign: "end" }}>
            <Typography style={styles.value}>{" "+activeuser.name}</Typography>
            <Typography style={styles.value}>{" "+activeuser.email}</Typography>
            <Typography style={styles.value}>{" "+activeuser.phone}</Typography>
            <Typography style={styles.value}>{" "+activeuser.user_type}</Typography>
        
            <Typography style={styles.value}>{" "+activeuser.country}</Typography>
            <Typography style={styles.value}>{" "+activeuser.state}</Typography>
            <Typography style={styles.value}>{" "+activeuser.city}</Typography>
            <Typography style={styles.value}>{" "+activeuser.address}</Typography>
            <Typography style={styles.value}>{" "+activeuser.pincode}</Typography>
            </Grid>
        </Grid>

         
      </Grid>
    </Card>
    </div>
    </div>);
 /* return (
    <div className="card basic-data-table">
      <div className="card-header">
        <h5 className="card-title mb-0"></h5>
      </div>
       <div className="card-body">
         
      <div>
                <label
                  className="form-label fw-bold text-neutral-900"
                  htmlFor="title"
                >
                 Name:
                </label>  {" "+activeuser.name}
                 
              </div>

              <div>
                <label
                  className="form-label fw-bold text-neutral-900"
                  htmlFor="title"
                >
                 Email:
                </label>  {" "+activeuser.email}
                 
              </div>
              <div>
                <label
                  className="form-label fw-bold text-neutral-900"
                  htmlFor="title"
                >
                 Phone:
                </label>  {" "+activeuser.phone}
                 
              </div>
              <div>
                <label
                  className="form-label fw-bold text-neutral-900"
                  htmlFor="title"
                >
                 User Type:
                </label>  {" "+activeuser.user_type}
                 
              </div>

      </div>
    </div>
  );*/
};

export default ProfileLayer;
